import { faInfo, faExclamation, faHourglass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import moment from "moment";
import type { CartNotificationPoint } from '../../notifications/Notification.types';

export default function PointInformation({ point, isFlash, showFormalNotMetCriteria = true }: { point: CartNotificationPoint, isFlash: boolean, showFormalNotMetCriteria?: boolean }) {

    let startOfEvent;
    const formalNotMetCriteriaMessages = [];
    if (point.notification_type !== 'flash') {
        const effectiveLt = point.rep_lt >= 0 ? point.rep_lt : point.rep_lt40 >= 0 ? point.rep_lt40 : null;
        let earliestPeakStar = false;
        if (effectiveLt !== null && (effectiveLt < 48 || effectiveLt > 168)) {
            earliestPeakStar = true;
            const onsetDate = moment.utc(point.Forecast_date, 'YYYYMMDDHH').add(effectiveLt, 'hours').format("YYYY-MM-DD HH:mm");
            const start2days = moment.utc(point.Forecast_date, 'YYYYMMDDHH').add(2, 'days').format("YYYY-MM-DD HH:mm");
            const end7days = moment.utc(point.Forecast_date, 'YYYYMMDDHH').add(7, 'days').format("YYYY-MM-DD HH:mm");
            formalNotMetCriteriaMessages.push(<div>* The onset of this event ({onsetDate}) does not fall within the required 2–7 day window ({start2days} – {end7days})</div>);
        }

        if (point.rep_lt >= 0) {
            startOfEvent = <Tooltip title={`Forecast date: ${point.Forecast_date}, Lead time: ${point.rep_lt}h`}><div>Earliest peak {earliestPeakStar && "*"}: {moment.utc(point.Forecast_date, 'YYYYMMDDHH').add(point.rep_lt, 'hours').format("YYYY-MM-DD HH:mm")}</div></Tooltip>;
        } else if (point.rep_lt40 >= 0) {
            startOfEvent = <Tooltip title={`Forecast date: ${point.Forecast_date}, Lead time (40%): ${point.rep_lt40}h`}><div>Earliest peak *: {moment.utc(point.Forecast_date, 'YYYYMMDDHH').add(point.rep_lt40, 'hours').format("YYYY-MM-DD HH:mm")}</div></Tooltip>;
            formalNotMetCriteriaMessages.push(<div>* This point did not exceed the 50% threshold for a Formal notification</div>);
        } else {
            startOfEvent = <Tooltip title="This point did not provide a leadtime for going over either of the 40% or 50% thresholds"><div>Earliest peak: could not be calculated <FontAwesomeIcon className="btn btn-outline-dark px-1 mx-0 fs-10" icon={faInfo} /></div></Tooltip>;
        }

        if (point.UpsArea < 1000) {
            formalNotMetCriteriaMessages.push(<div>* This point does not meet the 1000km² upstream area requirement for a Formal notification</div>);
        }
    } else {
        const startTime = moment.utc(point.Forecast_date, 'YYYYMMDDHH').add(point.rep_lt, 'hours');
        const isInPast = startTime.isBefore(moment());
        const hasPeakTime = typeof point.peak_lt === 'number' && point.peak_lt >= 0;
        const peakTime = hasPeakTime
            ? moment.utc(point.Forecast_date, 'YYYYMMDDHH').add(point.peak_lt, 'hours').format("YYYY-MM-DD HH:mm")
            : null;

        startOfEvent = <>
            <div>Likely start of event: <Tooltip title={`Forecast date: ${point.Forecast_date}, Lead time: ${point.rep_lt}h`}><span>{startTime.format("YYYY-MM-DD HH:mm")}</span></Tooltip> {isInPast && <Tooltip title="This is in the past!"><span className="text-danger"><FontAwesomeIcon icon={faHourglass} /><FontAwesomeIcon icon={faExclamation} /></span></Tooltip>}</div>
            {hasPeakTime && <div>Earliest peak: <Tooltip title={`Forecast date: ${point.Forecast_date}, Peak lead time: ${point.peak_lt}h`}><span>{peakTime}</span></Tooltip></div>}
        </>;
    }

    return <>
        <div>Country: {point.Country}</div>
        {!isFlash && <div>River: {point.RiverName}</div>}
        {isFlash && <div>Region: {point.ad2_name}</div>}
        <div>Upstream area {point.notification_type !== 'flash' && point.UpsArea < 1000 && "*"}: {point.UpsArea} km<sup>2</sup></div>
        <div className="mb-2">{startOfEvent}</div>
        {showFormalNotMetCriteria && formalNotMetCriteriaMessages.length > 0 && <div className="fs-9">
            {formalNotMetCriteriaMessages.map((message, index) => <div key={index} className="fst-italic">{message}</div>)}
        </div>}
    </>;
}
